<div class="container">
  <div class="card-panel mt-5">
    <form [formGroup]="entidadeForm" autocomplete="off">
      <div class="row">
        <div class="col-md-8">
          <lib-page-header page-title="EMPENHO EXTRA ORÇAMENTÁRIO"
            page-subtitle="EXERCÍCIO: {{login.exercicio.ano}} - {{login['ppa']['descricao']}}" page-change="{{pagTitulo}}"
            show-change="true" image-title="assets/img/invoice1.png">
          </lib-page-header>
        </div>
        <div class="col-md-4">
          <button (click)="sair()" class="btn btn-sm btn-outline-secondary float-right ml-5">
            <img src="assets/img/global/cross.png" alt="cvs" title="Sair" height="20" width="20">
          </button>
          <a [routerLink]="['/empenhos-extra']" class="btn btn-sm btn-outline-secondary float-right ml-2">
            <img src="assets/img/global/table_sort_filter.png" alt="pesquisa" title="Pesquisar" height="22" width="22">
          </a>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <label style="font-weight: bold; color: #757575">
            {{login.orgao.codigo}} {{login.orgao.nome}}
          </label>
        </div>
      </div>
      <hr class="mt-0 mb-4" />
      <div class="row">
        <div class="col-md-8">
          <div class="row">
            <div class="col-9">
              <label class=" mr-2" style="font-weight: bold; color: #009688 ">EMPENHO Nº:</label>
              <label type="text" readonly id="numero_"
                style="font-size: 18px; font-weight: bold; color: #009688 ">{{ ("00000" + entidadeForm.get('numero').value).slice(-5) }}</label>
            </div>
            <div class="col-3">

            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-4">
              <label for="data_empenho">Data empenho</label>
              <input value="{{entidadeForm.get('data_empenho').value | date:'dd/MM/yyyy':'GMT'}}" type="text"
                class="form-control-plaintext" id="data_empenho">
            </div>
            <div class="form-group col-md-4">
              <label for="data_vencto">Previsão pagto</label>
              <input value="{{entidadeForm.get('data_vencimento').value | date:'dd/MM/yyyy':'GMT'}}" type="text"
                class="form-control-plaintext" id="data_vencto">
            </div>
          </div>
          <div class="row">
            <div *ngIf="entidade.valor_empenho >= 0" class="form-group col-md-4 pb-0 mb-0">
              <label for="valor_empenho">Valor empenho</label>
              <input unmask="true" [imask]="imaskConfig" formControlName="valor_empenho" type="text"
                class="form-control-plaintext" id="valor_empenho" readonly placeholder="informe o valor"
                style="font-weight: bold; color: #1e88e5">
            </div>
            <div *ngIf="entidade.valor_empenho < 0" class="form-group col-md-4 pb-0 mb-0">
              <label for="valor_empenho">Valor anulado</label>
              <input unmask="true" [imask]="imaskConfig" formControlName="valor_empenho" type="text"
                class="form-control-plaintext" id="valor_empenho" readonly placeholder="informe o valor"
                style="font-weight: bold; color: red">
            </div>
            <div class="form-group col-md-4">
              <label for="processo">N˚ Processo</label>
              <input formControlName="processo" type="text" class="form-control-plaintext" id="processo">
            </div>
          </div>
          <div class="form-row mb-0 pb-0">
            <div class="form-group col-12 pt-0 mt-0 mb-0 pb-0">
              <label for="favorecido">Favorecido</label>
              <input *ngIf="entidade.favorecido" value="{{entidade.favorecido.cpf_cnpj | CPF}} {{entidade.favorecido.nome}}"
                readonly type="text" class="form-control-plaintext font-weight-bold" id="favorecido">
            </div>
          </div>
          <div class="form-row pt-0 mt-0">
            <div class="form-group col-12 pt-0 mt-0">
              <input *ngIf="entidade.favorecido" value="{{entidade.favorecido.endereco}}" readonly type="text"
                class="form-control-plaintext">
            </div>
          </div>
          <hr class="mt-3 mb-2" />
          <div class="row">
            <div class="col-md-8">
              <div class="form-row">
                <div class="form-group col-12">
                  <label for="ficha">Ficha Extra de despesa</label>
                  <input *ngIf="entidade.ficha" value="{{entidade.ficha.numero}} {{entidade.ficha.nome}}" readonly
                    type="text" class="form-control-plaintext" id="ficha">
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="card mb-3">
            <ul class="list-group list-group-flush">
              <li class="list-group-item">Empenhado <span class="float-right">{{empenhado | number:'1.2-2'}}</span></li>
              <li class="list-group-item">Pago <span class="float-right">{{pago | number:'1.2-2'}}</span></li>
            </ul>
          </div>
        </div>
      </div>
      <hr class="mt-3 mb-2" />
      <div class="form-row">
        <div class="form-group col-12">
          <label for="historico">Histórico</label>
          <textarea formControlName="historico" readonly class="form-control-plaintext" id="historico"
            rows="5"></textarea>
        </div>
      </div>
      <!-- <pre *ngIf="entidadeForm">{{ entidadeForm | json}}</pre> -->
    </form>
  </div>
</div>
